<template>
  <div  v-if="consulta" class="func-53">
    <funcionalidade-header :titulo="titulo" :custom-voltar="true" @click="voltar"></funcionalidade-header>
    <div>
      <mapa :config="mapConfig" :locations="locations" v-if="open" @close="open = false" :open-map="open"></mapa>
    </div>
    <div v-if="!open" id="detalhe-consulta">
      <el-row>
          <el-col :span="14">
            <div class="detalhes">
              <el-card class="detalhes-card">
                <div class="flex">
                  <div>
                    <span class="text-bold-max">{{medico.descricao}}</span>
                    <span class="text-regular">{{consulta.especialidade.descricao}}</span>
                    <el-button v-if="fullEndereco()"
                      @click="showContatos = true"
                      :style="'color:' + corTextoBotaoSecundario"
                      class="btn-text"
                      type="text">
                      Contatos
                    </el-button>
                  </div>
                  <div v-if="medico.urlFoto" class="foto-medico">
                    <img class="img-right" :src="medico.urlFoto">
                    <span class="crm-medico">{{medico.informacaoConselho}}</span>
                  </div>
                  <div style="display: grid;" v-if="!medico.urlFoto">
                    <inline-svg v-if="!medico.urlFoto" class="svg-right" :src="require('@/assets/img/Placeholder_doctor.svg')"></inline-svg>
                    <span class="crm-medico-svg">{{medico.informacaoConselho}}</span>
                  </div>
                </div>
              </el-card>
              <el-card class="detalhes-card">
                  <div class="flex">
                    <div>
                      <inline-svg width="20" class="align-center" :fill="estiloIconeNavegacao + '5A'" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"></inline-svg>
                      <span class="text-xg-bold">{{formatData(consulta.dataHora)}}</span>
                      <span class="text-sm-regular">{{formatDayName(consulta.dataHora)}}</span>
                    </div>
                    <div>
                      <inline-svg width="20" class="align-center" :fill="estiloIconeNavegacao + '5A'" :src="require('@/assets/icons/Icon_schedule_clock.svg')"></inline-svg>
                      <span class="text-xg-bold">{{formatHora(consulta.dataHora)}}</span>
                    </div>
                    <div>
                    </div>
                  </div>
                </el-card>

              <el-tabs v-model="activeTab">
                <el-tab-pane label="Informações" name="informacoes">
                  <el-card v-if="consulta.tipoAgenda === '1'" class="detalhes-card">
                    <div class="tipo-agenda">
                      <span class="text-g-bold">{{tipoConsulta}}</span>
                      <span v-if="statusColor === '#FFBB02'" class="text-regular alinhamento" v-html="countDown(consulta.dataHora)"></span>
                      <span v-if="statusColor !== '#FFBB02'" class="text-g-bold alinhamento bold" :style="`color:${statusColor}`">{{status}}</span>
                    </div>
                    <span class="text-regular bold">{{consulta.localAtendimento.descricao}}</span>
                    <span class="text-sm" v-html="fullEndereco(consulta.localAtendimento.endereco)"></span>
                    <div style="display: flex; justify-content: space-between">
                      <div>
                        <el-button class="btns-card" @click="showContatos = true">
                          <span :style="`color: ${corTextoBotaoSecundario}`">Contatos</span>
                        </el-button>
                        <el-button v-if="openMapValid" @click="openMap" class="btns-card">
                          <span :style="`color: ${corTextoBotaoSecundario}`">Ver no mapa</span>
                        </el-button>
                      </div>
                      <inline-svg class="img-card" :fill="corPrimaria + '5A'" :src="require('@/assets/img/img_consulta_agendar.svg')"></inline-svg>
                    </div>
                  </el-card>
                  <el-card v-if="consulta.tipoAgenda === '2'" class="detalhes-card">
                    <div>
                      <div class="tipo-agenda">
                        <span class="text-g-bold">{{tipoConsulta}}</span>
                        <span class="text-regular alinhamento" v-html="countDown(consulta)"></span>
                      </div>
                      <div style="display: flex;">
                        <div style="display: flex; flex-direction: column; gap: 10px;">
                          <!--                        <el-button class="btn-padrao" @click="goBaixarApp" :style="`background: ${corBotaoPrincipal}; color: ${corTextoBotaoPrincipal}`">-->
                          <!--                          <inline-svg style="margin-right: 2px" :fill="corSecundaria"  :src="require('@/assets/icons/icon_mini_download.svg')"></inline-svg>-->
                          <!--                         <span class="text-btn-primary"> Instale o Aplicativo </span>-->
                          <!--                        </el-button>-->
                          <div v-if="consulta.meeting && consulta.meeting.responsavelAtendimento && consulta.meeting.responsavelAtendimento.nome">
                            Responsável: {{consulta.meeting.responsavelAtendimento.nome}}
                          </div>
                          <div v-if="verificaPendencias">
                            <el-button @click="gotoPendencias()" class="btn" style="background-color: #E8AA00; color:#FFFFFF; border: none; font-weight: normal;">
                              <inline-svg style="vertical-align: bottom;" :src="require('@/assets/icons/icon_mini_info.svg')" />
                              Pendências a resolver
                            </el-button>
                          </div>
                          <div style="display: flex;">
                            <img class="img-app" :src="require('@/assets/img/img_download_ios.png')" style=" margin-bottom: 5px; cursor: pointer;" @click="goToAppStore">
                            <img class="img-app" :src="require('@/assets/img/img_download_android.png')" style=" margin-bottom: 5px; cursor: pointer;" @click="goToGooglePlay">
                          </div>
                          <span class="text-sm">{{textoConsultaFutura}}</span>
                        </div>
                        <div>
                          <inline-svg height="89" width="80" :fill="corPrimaria + '5A'" class="img-right-card" :src="require('@/assets/img/img_consulta_agora.svg')"></inline-svg>
                        </div>
                      </div>
                    </div>
                  </el-card>
                  <span style="margin-bottom: 10px" class="text-g-bold">Paciente</span>
                  <el-card class="detalhes-card mb-10">
                    <div style="display: flex; justify-content: space-between">
                      <div>
                        <span class="text-md-bold">{{consulta.paciente.nome}}</span>
                        <span>{{matricula}} </span>
                        <span>{{tipoPaciente(consulta.paciente.idTipoUsuario)}}</span>
                      </div>
                      <div :style="`background: ${estiloIconeNavegacao}A5`" class="background">
                        <span class="iniciais-paciente">{{iniciais (consulta.paciente.nome)}}</span>
                      </div>
                    </div>
                  </el-card>
                  <el-card class="detalhes-card">
                    <span class="text-sm">Contato:</span>
                    <span v-for="(item, i) in contatos" :class="i> 0 ? 'contatos' : 'bold'" :key="i">{{item.valor}}</span>
                  </el-card>
                  <el-card class="detalhes-card" v-if="exibeTipoServico">
                    <span>{{ labelServico }}</span>
                  </el-card>
                </el-tab-pane>
                <el-tab-pane v-if="hasOcorrenciaMeeting" label="Histórico" name="historico">
                  <HistoricoOcorrencia :idOcorrencia="consulta.meeting.ocorrencia.idOcorrencia"></HistoricoOcorrencia>
                </el-tab-pane>
                <el-tab-pane v-if="hasOcorrenciaMeeting" label="Anexos" name="anexos">
                  <AnexosOcorrencia :idOcorrencia="consulta.meeting.ocorrencia.idOcorrencia"></AnexosOcorrencia>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>

          <el-col :span="10">
            <div class="line"></div>
            <div v-if="consulta.status.motivo">
              <el-card :body-style="{display: 'flex'}" class="card-cancelado">
                <div>
                  <el-button class="cancelado-btn" type="text" @click="closeAlert">
                    <inline-svg class="svg-margin" :src="require('@/assets/icons/Icon_boleto_exclude.svg')"></inline-svg>
                  </el-button>
                </div>
                <div style="padding: 4px">
                  <span class="card-cancelado-text">{{consulta.status.motivo}}</span>
                </div>
              </el-card>
            </div>
            <div v-if="consulta.numeroProtocolo" class="btns btns-padding">
              <el-card class="detalhes-card">
                <span class="text-sm">PROTOCOLO</span>
                <span class="bold" :style="`color: ${corPrimaria}; font-size: large`" >{{consulta.numeroProtocolo}}</span>
                <inline-svg @click="copiarNumeroProtocolo" :fill="corPrimaria" class="arrow" :src="require('@/assets/icons/icon_btn_copy.svg')"></inline-svg>
              </el-card>
              <div v-if="hasMeeting && permiteAlterarResponsavelAtendimento" @click="gotoAlterarResponsavel">
                <el-card :style="`background: ${corPrimaria};`" class="btn-primario">
                  <div style="display: flex; gap: 10px; align-items: center;">
                    <i class="material-icons-outlined" style="font-size: 15px; color: #fff;">edit</i>
                    <span class="bold" :style="`color: #fff`">Alterar responsável</span>
                  </div>
                </el-card>
              </div>
              <div v-if="verificarValidadeData(consulta.dataHora)" @click="salvarAgenda">
                <el-card :style="`background: ${corPrimaria}2F`" class="btn-primario">
                  <span class="bold" :style="`color: ${corPrimaria}`">Salvar na agenda</span>
                  <inline-svg :fill="corPrimaria" class="arrow" :src="require('@/assets/icons/Arrow_chevron.svg')"></inline-svg>
                </el-card>
              </div>
            </div>

            <div class="card-confirmacao">
              <div style="display: flex;flex-direction:column;padding: 15px">
                <div class="desc">
                  <span class="title">Confirmar consulta</span>
                  <span class="info">Indique ao seu médico que está tudo certo e você irá comparecer. Se houver algum imprevisto, faça o cancelamento para que possamos realocar a agenda.</span>
                </div>
                <div class="btns-actions">
                  <confirmar-cancelar-consulta :agenda="consulta" modelo="switch" @success="getDetalhe"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      <dialog-default
        v-if="showDialog"
        :show-close="false"
        custom-class="dialog-cancelar"
        :title="'Cancelar consulta?'"
        :open.sync="showDialog"
        width="47%"
      >
        <span>Tem certeza de que deseja cancelar esta consulta?</span>
        <span slot="footer" class="dialog-footer">
          <div style="display: flex">
              <el-button class="btn-dialog" :style="`background-color: ${corBotaoSecundario}`" @click="showDialog = false">
                <span :style="`color: ${corTextoBotaoSecundario}`">Ainda Não</span>
              </el-button>
              <el-button class="btn-dialog" :style="`background-color: ${corBotaoPrincipal}`" @click="cancelarConsulta">
                <span :style="`color: ${corTextoBotaoPrincipal}`">Cancelar consulta</span>
              </el-button>
          </div>
        </span>
      </dialog-default>

      <DialogDefault
        :open.sync="showContatos"
        :title="'Contatos'"
        @close="showContatos = false">
          <el-row class="borders">
            <div
              v-if="consulta.tipoAgenda === '1'"
              style="margin: 12px 0;"
            >
            <el-col :span="8">
              <b>Endereço</b>
            </el-col>
            <el-col :span="16">
             <span v-html="fullEndereco()"></span>
               <el-button v-if="openMapValid" class="btn-dialog-contatos" :style="`background-color: ${corBotaoSecundario}`" @click="openMap">
                <span :style="`color: ${corTextoBotaoSecundario}`">Ver no mapa</span>
                <inline-svg :fill="corTextoBotaoSecundario" class="icon-btn" :src="require('@/assets/icons/Arrow_chevron.svg')"></inline-svg>
              </el-button>
          </el-col>
          </div>
        </el-row>
      </DialogDefault>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { mapGetters, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'
import moment from 'moment'
import Mapa from '@/components/mapa/Mapa'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import ConfirmarCancelarConsulta from '@/views/53/components/ConfirmarCancelarConsulta.vue'
import HistoricoOcorrencia from '@/components/HistoricoOcorrencia/HistoricoOcorrencia.vue'
import AnexosOcorrencia from '@/components/AnexosOcorrencia/AnexosOcorrencia.vue'
export default {
  data () {
    return {
      consulta: null,
      open: false,
      showDialog: false,
      showContatos: false,
      locations: [],
      mapConfig: {
        open: false,
        showHeader: true,
        height: '634px',
        zoom: 15
      },
      activeTab: 'informacoes'
    }
  },
  components: { AnexosOcorrencia, HistoricoOcorrencia, ConfirmarCancelarConsulta, DialogDefault, FuncionalidadeHeader, inlineSvg, Mapa },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao']),
    ...mapGetters('Login', ['user', 'beneficiarios']),
    estiloIconeNavegacao () {
      return {
        color: this.funcionalidade.parametros.corIconeNavegacao
      }
    },
    medico () {
      return this.consulta.profissional
    },
    contatos () {
      return this.consulta.paciente.contatos
    },
    openMapValid () {
      return this.local.endereco.latitude && this.local.endereco.longitude
    },
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    corBotaoSecundario () {
      return this.estilo.botaoSecundario.corBotaoSecundario
    },
    corTextoBotaoSecundario () {
      return this.estilo.botaoSecundario.corTextoBotaoSecundario
    },
    textoConsultaFutura () {
      return this.funcionalidade.parametros.textos.textoDetalheTeleconsultaFuturoWeb
    },
    permiteAlterarResponsavelAtendimento () {
      return this.funcionalidade.parametros.permiteAlterarResponsavelAtendimento
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corSecundaria () {
      return this.estilo.aplicacao.corSecundariaAplicacao
    },
    matricula () {
      const paciente = this.beneficiarios.find(el => el.chaveUnica === this.consulta.paciente.chaveUnica)
      return paciente ? paciente.dadosDoPlano.matricula : ''
    },
    status () {
      return this.consulta.status.descricao
    },
    statusColor () {
      return this.consulta.status.cor
    },
    local () {
      return this.consulta.localAtendimento
    },
    titulo () {
      let titulo
      if (this.consulta.tipoAgenda === '1') {
        titulo = `Consulta ${this.status}`
      } else {
        titulo = `Teleconsulta ${this.status}`
      }
      return titulo
    },
    tipoConsulta () {
      let tipo
      if (this.consulta.tipoAgenda === '1') {
        tipo = 'Consulta Presencial'
      } else {
        tipo = 'Teleconsulta'
      }
      return tipo
    },
    labelServico () {
      return this.consulta.especialidade.servico.descricao
    },
    exibeTipoServico () {
      return !!(this.consulta.especialidade.servico && this.consulta.especialidade.servico.descricao)
    },
    hasMeeting () {
      return this.consulta.meeting
    },
    hasOcorrenciaMeeting () {
      return this.hasMeeting && this.consulta.meeting.ocorrencia && this.consulta.meeting.ocorrencia.idOcorrencia
    },
    verificaPendencias () {
      return (
        this.consulta.tipoAgenda === '2' &&
        this.hasMeeting &&
        this.consulta.meeting.responsavelAtendimento &&
        Object.values(this.consulta.meeting.responsavelAtendimento.pendencias).some(item => item.valor === false)
      )
    }
  },
  methods: {
    voltar () {
      this.$router.push({ path: '/53' })
    },
    gotoPendencias () {
      this.$router.push({ path: '/53/pendencias', query: { idAgenda: this.consulta.idAgenda } })
    },
    gotoAlterarResponsavel () {
      this.$router.push({ path: '/53/alterarResponsavel', query: { consulta: this.$route.query.consulta } })
    },
    async getDetalhe () {
      const res = await this.apiFuncionalidade.detalheConsulta({
        payload: {
          idAgenda: this.$route.query.idRegistro || this.$route.query.consulta.idAgenda
        },
        loading: true
      })
      this.consulta = res.data
    },
    verificarValidadeData (data) {
      return moment().isBefore(data)
    },
    goToAppStore () {
      window.open(`${this.aplicacao.textos.urlAppStore}`)
    },
    goToGooglePlay () {
      window.open(`${this.aplicacao.textos.urlGooglePlay}`)
    },
    closeAlert () {
      this.$set(this.consulta.status, 'motivo', false)
    },
    openMap () {
      const lat = parseFloat(this.local.endereco.latitude)
      const lng = parseFloat(this.local.endereco.longitude)
      this.locations = [{
        coordenadas: [{ lat: lat, long: lng }],
        endereco: this.fullEndereco
      }]
      this.open = true
    },
    async init () {
      await this.getDetalhe()
    },
    formatData (data) {
      return moment(data.toString()).format('DD/MM/YY')
    },
    async cancelarConsulta () {
      const res = await this.apiFuncionalidade.cancelarConsulta({
        payload: {
          idAgenda: this.consulta.idAgenda
        }
      })
      if (res.status === true) {
        this.$router.go(-1)
      }
    },
    formatDayName (value) {
      const diaSemana = moment(value).locale('pt-br').format('dddd')
      return diaSemana.replace(diaSemana.charAt(), diaSemana.charAt().toUpperCase())
    },
    formatHora (val) {
      return moment(val.toString()).format('HH:mm')
    },
    countDown (val) {
      const hoje = moment()
      const data = moment(val.dataHora)
      if (hoje.isBefore(val.dataHora) && !val.status.encerrado) {
        const diferenca = data.diff(hoje, 'days')

        if (diferenca === 0) {
          const hours = data.diff(hoje, 'hours')
          if (hours <= 0) {
            const minutes = data.diff(hoje, 'minutes')
            if (minutes >= 1) {
              return `Faltam <strong"> ${minutes} </strong> minutos`
            }
            return ''
          }
          return `Faltam <strong> ${hours} </strong> horas`
        }
        if (diferenca < 0) {
          return ''
        }
        return `Faltam <strong> ${diferenca} </strong> dias`
      } else {
        return `<p style="color: ${val.status.cor}"> ${val.status.descricao} </p>`
      }
    },
    iniciais (val) {
      const letras = val.match(/\b(\w)/g)
      const fim = letras.length - 1
      const result = [letras[0], letras[fim]]
      return result.join('')
    },
    fullEndereco () {
      if (this.local && this.local.endereco && this.local.endereco.endereco) {
        return ` ${this.local.endereco.cidade}, ${this.local.endereco.bairro} </br> ${this.local.endereco.endereco}, ${this.local.endereco.numero} `
      } else {
        return false
      }
    },
    tipoPaciente (val) {
      if (val === 'T') {
        return 'Titular'
      }
      if (val === 'D') {
        return 'Dependente'
      }
    },
    salvarAgenda () {
      const event = {
        title: `Consulta médica com ${this.medico.descricao} - ${this.consulta.especialidade.descricao}`,
        startTime: new Date(this.consulta.dataHora),
        endTime: new Date(this.consulta.dataHora),
        location: this.consulta.localAtendimento.descricao
      }

      this.googleCalendarLink = `http://www.google.com/calendar/event?action=TEMPLATE&text=${event.title || ''}
      &dates=${this.formatDate(event.startTime)}/${this.formatDate(event.endTime)}&details=${event.details || ''}
      &location=${event.location || ''}`

      window.open(this.googleCalendarLink, '_blank')
    },
    formatDate (date) {
      const day = date.getUTCDate()
      const monthIndex = date.getUTCMonth()
      const year = date.getUTCFullYear()

      const hour = date.getUTCHours()
      const minutes = date.getUTCMinutes()

      let formattedDate
      if (hour === 0 && minutes === 0) {
        formattedDate = ('' + year) + this.zeroNum(monthIndex + 1) + this.zeroNum(day)
      } else {
        formattedDate = ('' + year) + this.zeroNum(monthIndex + 1) + this.zeroNum(day) + 'T' + this.zeroNum(hour) + this.zeroNum(minutes) + '00Z'
      }
      return formattedDate
    },
    zeroNum (num) {
      if (num < 10) return '0' + num
      return num
    },
    copiarNumeroProtocolo () {
      const numeroProtocolo = this.consulta.numeroProtocolo
      if (numeroProtocolo) {
        navigator.clipboard.writeText(numeroProtocolo)
        this.$notify[('success')]({
          title: 'Protocolo copiado!',
          message: 'Número de protocolo copiado para a área de transferência!',
          position: 'top-right',
          duration: 2000
        })
      }
    }
  },
  async created () {
    await this.init()
  }
}
</script>
<style scoped>
.func-53 .card-confirmacao {
  background: #FFFFFF 0 0 no-repeat padding-box;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  margin:10px 20px;

}
.func-53 .card-confirmacao .desc {
  display: flex;
  flex-direction: column;
  padding: 2px;
}
.func-53 .card-confirmacao .desc .title {
  text-align: left;
  font: normal normal 600 15px/20px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 10px;
}
.func-53 .card-confirmacao .desc .info {
  text-align: left;
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
}
.func-53 .card-confirmacao .btns-actions > div{
  display: flex;
  :nth-child(1) {
    margin-right: 8px;
  }
}
</style>
